export default "__VITE_ASSET__D2R0nhJM__"